module.exports = __webpack_public_path__ + "assets/Iota.cdb33e86bcbf01623a490598cd189395.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Iota.png
// module id = 835
// module chunks = 0